import React from 'react';
import { useNetworkStatus } from '../../lib/useNetworkStatus';
import { WifiOff, Zap, ShieldCheck } from 'lucide-react';

export const OfflineBanner: React.FC = () => {
  const { isOnline, isLowBandwidth, saveData } = useNetworkStatus();

  if (isOnline && !isLowBandwidth && !saveData) {
    return null;
  }

  return (
    <div className="bg-slate-900 border-b border-slate-800 text-xs px-4 md:px-8 lg:px-12 py-2 flex items-center justify-between text-white transition-all sticky top-0 z-50">
      {!isOnline ? (
        <div className="flex items-center gap-2 text-amber-400 font-semibold w-full">
          <WifiOff className="w-4 h-4 text-amber-400 shrink-0 animate-pulse" />
          <span>
            <strong>Offline Physics Engine Active:</strong> You are currently offline. Local load calculations, solar physics, and system package specifications are fully accessible offline.
          </span>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-emerald-400 font-semibold w-full">
          <Zap className="w-4 h-4 text-emerald-400 shrink-0" />
          <span>
            <strong>Low Bandwidth Mode Detected:</strong> Animations and high-res assets optimized for fast sub-1.8s mobile page response.
          </span>
        </div>
      )}
    </div>
  );
};
